<template>
  <div v-if="pageDevice != null">

    <deviceTabs v-if="isLoginUserPageItemReadable" :current="'sensors'" :pageDevice="pageDevice" :pageUser="pageUser">
      <b-button v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable" :disabled=" doingBackup || (countAttributes(pageDevice.sensors) > 7)" v-b-modal.addNewSensorFloat size="sm" class="displayNoneMax589 float-right tabButton" variant="danger">
        센서 추가하기
      </b-button>
      <b-button v-if="!pageDevice.disabled && pageDevice.useSensorsResponse" v-b-modal.sensorsJsonFloat :disabled="!pageBinded || pageDevice.disabled" size="sm" class="displayNoneMax777 float-right tabButton mr-2" variant="secondary">
        센서설정 다운로드
      </b-button>
    </deviceTabs>

    <div :class="(isLoginUserPageItemWritable)? 'writable':'notWritable'">

      <div v-if="isLoginUserPageItemWritable">
        <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="pageDevice.disabled">
          정지 중이므로 기기의 정보를 변경할 수 없습니다.
        </b-alert>
      </div>

      <p class="mt-2 pt-0 gothic">
        현재 {{ countAttributes(pageDevice.sensors) }} 개의 센서가 등록되어 있습니다. 기기가 생성되면 자동으로 조도센서, 온도/습도/기압 센서, 버튼 센서를 추가합니다. 필요없는 경우에는 삭제하시기 바랍니다. 하나의 기기에 최대 7개의 센서를 추가할 수 있습니다. <span v-if="pageDeviceSensorsLength <= 7">필요한 경우에
        <b-button v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable" :disabled="doingBackup || (countAttributes(pageDevice.sensors) > 7)" v-b-modal.addNewSensorFloat size="sm" class="pl-1 pr-1 pt-dot1 pb-dot1 m-0 fontSizeDot8" style="vertical-align: 2px;" variant="danger">새로운 센서를 추가</b-button>할 수 있습니다.</span>
      <p>

      <div v-for="sensor, index in sortedSensors" :key="index">

        <h3 :class="(sensor.id == newlyAddedSensorId)? 'mt-3 mb-0 p-2 border font-weight-bold fontSize1dot5 cursor-pointer border-warning-dark bg-warning-lighter menuRow' : 'mt-3 mb-0 p-2 border border-secondary font-weight-bold fontSize1dot5 cursor-pointer menuRow'" @click="toggleSensorCollapsed(sensor.name)" style="grid-template-columns: auto auto;">

          <div style="grid-area: left;">
            <b-badge variant="warning" size="sm" v-if="sensor.id == newlyAddedSensorId" class="mt-1 mr-1 pt-dot2 pb-dot2" style="vertical-align: 2px;">new</b-badge>
            {{sensor.name}}
            ({{sensor.title}})
          </div>

          <div style="grid-area: right; text-align: right;">

            <b-button type="button" variant="primary" size="sm" class="pt-dot1 pb-dot1" :disabled="doingBackup" v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable && typeof(showDeleteButton[sensor.name]) != 'undefined' && showDeleteButton[sensor.name] == true && (sensor.lastBook != 0 || sensor.lastIndex != -1) && typeof(backupUri[sensor.name]) != 'undefined' && backupUri[sensor.name] != null" :href="backupUri[sensor.name]" :download="`${sensor.name}_backup.csv`">
              백업파일 다운로드
            </b-button>

            <!--b-button type="button" variant="primary" size="sm" class="mr-2 pt-dot1 pb-dot1" @click="removeBackupUri(sensor.name, $event)" :disabled="doingBackup" v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable && typeof(showDeleteButton[sensor.name]) != 'undefined' && showDeleteButton[sensor.name] == true && (sensor.lastBook != 0 || sensor.lastIndex != -1) && typeof(backupUri[sensor.name]) != 'undefined' && backupUri[sensor.name] != null">
              백업 지우기
            </b-button-->

            <b-button type="button" variant="primary" size="sm" class="mr-1 pt-dot1 pb-dot1" @click="backupSensorData(sensor.name, $event)" :disabled="doingBackup" v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable && typeof(showDeleteButton[sensor.name]) != 'undefined' && showDeleteButton[sensor.name] == true && (sensor.lastBook != 0 || sensor.lastIndex != -1) && (typeof(backupUri[sensor.name]) == 'undefined' || backupUri[sensor.name] == null)">
              백업파일 만들기
            </b-button>

            <b-button type="button" variant="danger" size="sm" class="mr-1 pt-dot1 pb-dot1" @click="deleteSensorData(sensor.name, $event)" :disabled="doingBackup" v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable  && typeof(showDeleteButton[sensor.name]) != 'undefined' && showDeleteButton[sensor.name] == true && (sensor.lastBook != 0 || sensor.lastIndex != -1)">
              데이터 삭제
            </b-button>

            <b-button type="button" variant="secondary" size="sm" class="mr-1 pt-dot1 pb-dot1" @click="deleteSensor(sensor.name, $event)" :disabled="doingBackup" v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable && (typeof(showDeleteButton[sensor.name]) == 'undefined' || showDeleteButton[sensor.name] == false)">
              센서 삭제
            </b-button>

            <b-button size="sm" type="button" variant="primary" class="mr-1 pt-dot1 pb-dot1" @click="updateSensor(sensor.name, $event)" :disabled="doingBackup" v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable">
              설정 저장
            </b-button>

          </div>
        </h3>

        <b-collapse :id="'sensorBlock_' + sensor.name" :class="(sensor.id == newlyAddedSensorId)? 'm-0 border border-top-0 p-2 pl-3 pr-3 border-warning-dark' : 'm-0 border border-top-0 p-2 pl-3 pr-3 border-secondary'" v-model="sensorsCollapsed[sensor.name]">

          <b-form :id="'sensorForm_' + sensor.name" @submit.stop.prevent class="was-validated">
            <div class="mt-1 gothic gridColumn">
              <div class="gridColumnTitle">
                센서 ID
              </div>
              <div class="gridColumnBody">
                {{sensor.id}}
              </div>
            </div>

            <div class="mt-1 gothic gridColumn">
              <div class="gridColumnTitle">
                센서 이름
              </div>
              <div class="gridColumnBody">
                {{sensor.name}}
              </div>
            </div>

            <div class="mt-1 gothic gridColumn" v-if="sensor.lastValuesModified">
              <div class="gridColumnTitle">
                최종 수정일
              </div>
              <div class="gridColumnBody">
                {{dateToString(sensor.lastValuesModified.toDate())}}
              </div>
            </div>

            <div class="mt-1 gothic gridColumn">
              <div class="gridColumnTitle">
                데이터 줄 수
              </div>
              <div class="gridColumnBody">
                {{(sensor.lastBook*1000 + sensor.lastIndex + 1).toLocaleString("ko-KR")}}
              </div>
            </div>

            <div class="mt-1 gothic gridColumn">
              <div class="gridColumnTitle">
                공개 여부
              </div>
              <div class="gridColumnBody">
                {{(sensor.open)?"공개":"공개 안함"}}
              </div>
            </div>

            <div class="mt-1 gothic gridColumn" v-if="isLoginUserPageItemWritable">
              <div class="gridColumnTitle">
                친구 목록
              </div>
              <div class="gridColumnBody">
                <span v-for="friend in sensor.frApp" :key="friend" class="mr-2">
                  <router-link v-if="sensor.frAppCache[friend]" :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{ (sensor.frAppCache[friend].displayName)? sensor.frAppCache[friend].displayName : friend }}
                    </span>
                  </router-link>
                  <router-link v-else :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{ friend }}
                    </span>
                  </router-link><a v-if="sensor.frAppCache[friend]&&sensor.frAppCache[friend].email" :href="`mailto:${sensor.frAppCache[friend].email}`">({{ sensor.frAppCache[friend].email }})</a>
                </span>
              </div>
            </div>

            <div class="mt-1 gothic gridColumn">
              <div class="gridColumnTitle">
                센서 타입
              </div>
              <div class="gridColumnBody">
                {{sensor.type}}
              </div>
            </div>

            <b-input-group size="sm" class="mt-1">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorCategory_' + sensor.name"  class="m-0 p-0">센서 분류</label>
              </b-input-group-text>
              <b-form-select required  :options="sensorCategoryOptions" size="sm" v-b-tooltip.focus title="센서의 분류입니다. I2C, SERIAL, DIGITAL, ANALOG, ETC 중에 선택해주세요." v-model="sensor.category" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable || sensor.type !='CUSTOM'" :id="'sensorCategory_' + sensor.name"/>
            </b-input-group>

            <b-input-group size="sm" class="mt-1">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorTitle_' + sensor.name"  class="m-0 p-0">화면 제목</label>
              </b-input-group-text>
              <b-form-input  v-touch:swipe.stop :id="'sensorTitle_' + sensor.name" v-model="sensor.title" trim size="sm" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable" v-b-tooltip.focus title="화면할 표시될 센서의 제목입니다.
              최소 2글자, 최대 16글자입니다." minlength="2" maxlength="16" required/>
            </b-input-group>

            <b-input-group size="sm" class="mt-1">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorType_' + sensor.name" class="m-0 p-0">사용</label>
              </b-input-group-text>
              <b-form-select required :options="sensorDisabledOptions" size="sm" v-b-tooltip.focus title="센서의 사용여부입니다. Disabled로 지정하면 해당 센서는 데이터를 받을 수 없으며 IoT 기기에 보내는 센서 목록에서도 빠집니다." v-model="sensor.disabled" :id="'sensorDisabled_' + sensor.name" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>

            <b-input-group size="sm" class="mt-1">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorRead_' + sensor.name" class="m-0 p-0">읽기 간격</label>
              </b-input-group-text>
              <b-form-input  :number="true" v-touch:swipe.stop :id="'sensorRead_' + sensor.name" v-model="sensor.read" trim size="sm" v-b-tooltip.focus title="IoT 기기에서 센서를 읽는 간격입니다. 단위는 1/1000초입니다. 지정하지 않으면 센서의 기본값을 사용합니다. 센서의 기본값은 센서마다 다릅니다. 0으로 지정하면 읽지 않습니다." type="number" min="0" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>

            <b-input-group size="sm" class="mt-1">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :id="'sensorUpdate_' + sensor.name" class="m-0 p-0">전송 간격</label>
              </b-input-group-text>
              <b-form-input :number="true" v-touch:swipe.stop :id="'sensorUpdate_' + sensor.name" v-model="sensor.update" trim size="sm" v-b-tooltip.focus title="IoT 기기에서 읽은 값을 업로딩하는 간격입니다. 단위는 1/1000초입니다. 0 또는 60000 이상의 정수입니다. 지정하지 않으면 기기의 기본값을 사용하고, 0으로 지정하면 업로드하지 않습니다." pattern="^0|([6-9]\d\d\d\d)|([1-9]\d{5,})$" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>


            <b-input-group size="sm" class="mt-1" v-if="sensor.category != 'i2c' && sensor.category != 'serial'">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorPin_' + sensor.name" class="m-0 p-0">핀</label>
              </b-input-group-text>
              <b-form-input  v-touch:swipe.stop v-model="sensor.pin" trim size="sm" v-b-tooltip.focus title="센서가 사용중인 pin의 이름입니다. 센서 중에 아날로그, 디지털 핀을 사용하는 센서만 설정합니다. " :id="'sensorPin_' + sensor.name" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>

            <b-input-group size="sm" class="mt-1" v-if="sensor.category == 'i2c'">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorAddress_' + sensor.name" class="m-0 p-0">주소</label>
              </b-input-group-text>
              <b-form-input  v-touch:swipe.stop v-model="sensor.address" trim size="sm" v-b-tooltip.focus title="센서가 I2C 통신에 사용하는 주소입니다. I2C 센서에서만 사용합니다. " :id="'sensorAddress_' + sensor.name" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>

            <b-input-group size="sm" class="mt-1" v-if="sensor.category == 'serial'">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorRx_' + sensor.name" class="m-0 p-0">RX 핀</label>
              </b-input-group-text>
              <b-form-input  v-touch:swipe.stop v-model="sensor.rx" trim size="sm" v-b-tooltip.focus title="센서가 시리얼 통신에 사용하는 rx 핀의 이름입니다. 시리얼 통신을 하는 경우에만 사용합니다. " :id="'sensorRx_' + sensor.name" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>

            <b-input-group size="sm" class="mt-1" v-if="sensor.category == 'serial'">
              <b-input-group-text slot="prepend" class="leftCellTitle">
                <label :for="'sensorTx_' + sensor.name" class="m-0 p-0">TX 핀</label>
              </b-input-group-text>
              <b-form-input  v-touch:swipe.stop v-model="sensor.tx" trim size="sm" v-b-tooltip.focus title="센서가 시리얼 통신에 사용하는 tx 핀의 이름입니다. 시리얼 통신을 하는 경우에만 사용합니다. " :id="'sensorTx_' + sensor.name" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>

            <div class="mt-1 gothic gridColumn">
              <div class="gridColumnTitle">
                값들
              </div>
              <div class="gridColumnBody">

                <div v-for="(value, index) in sensor.values" :key="index">
                  <div style="display: flex;" class="mt-2 mb-3 ml-2">
                    <div style="order: 1; flex-grow: 1;">
                      <b-input-group size="sm" class="mt-1">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label :for="'newSensorValueName_' + sensor.name + '_' + index" class="m-0 p-0 fontSizeDot8">이름</label>
                        </b-input-group-text>
                        <b-form-input  v-touch:swipe.stop trim size="sm" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable" v-b-tooltip.focus title="데이터의 이름입니다. 데이터를 전송할 때 키로 사용합니다. 이름은 최소 2글자, 최대 6글자입니다. 첫 글자는 _, 알파벳, 다른 글자는 숫자도 가능합니다." pattern="^[a-zA-Z_$][a-zA-Z_$0-9]{1,15}$" minlength="2" maxlength="6" required v-model="value.name" class="rounded-0 font-weight-bold border-bottom-0 fontSizeDot8" :id="'newSensorValueName_' + sensor.name + '_' + index"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label :for="'newSensorValueName_' + sensor.name + '_' + index" class="m-0 p-0 fontSizeDot8">화면 제목</label>
                        </b-input-group-text>
                        <b-form-input  v-touch:swipe.stop trim size="sm" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable" v-b-tooltip.focus title="화면에 표시될 데이터의 제목입니다. 최소 2글자, 최대 16글자입니다." minlength="2" maxlength="16" required v-model="value.title" class="rounded-0 border-bottom-0 fontSizeDot8"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label :for="'newSensorValueName_' + sensor.name + '_' + index" class="m-0 p-0 fontSizeDot8">데이터 형식</label>
                        </b-input-group-text>
                        <b-form-select v-if="sensor.type == 'CUSTOM' || value.type == 'string' || sensor.lastValues == null" required :options="sensorValueTypeOptions" v-b-tooltip.focus title="데이터의 형식입니다." v-model="value.type" class="rounded-0 border-bottom-0 fontSizeDot7" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
                        <b-form-input  v-touch:swipe.stop v-else trim size="sm" disabled="disabled" v-b-tooltip.focus title="데이터의 형식입니다." v-model="value.type" readonly="readonly" class="rounded-0 border-bottom-0 fontSizeDot7"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label class="m-0 p-0">단위</label>
                        </b-input-group-text>
                        <b-form-input  v-touch:swipe.stop trim size="sm" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable" v-b-tooltip.focus title="값의 단위입니다. 최대 4글자입니다. " maxlength="4" v-model="value.unit" class="rounded-0 border-bottom-0 fontSizeDot8"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label class="m-0 p-0">최솟값</label>
                        </b-input-group-text>
                        <b-form-input :number="true" v-touch:swipe.stop trim size="sm" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable" v-b-tooltip.focus :title="valueTypeList[value.type].title" :min="valueTypeList[value.type].title.min" max="valueTypeList[value.type].max" v-model="value.min" class="rounded-0 border-bottom-0 fontSizeDot8"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label class="m-0 p-0">최댓값</label>
                        </b-input-group-text>
                        <b-form-input :number="true" v-touch:swipe.stop trim size="sm" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable" v-b-tooltip.focus :title="valueTypeList[value.type].title" :min="valueTypeList[value.type].title.min" max="valueTypeList[value.type].max" v-model="value.max" class="rounded-0 border-bottom-0 fontSizeDot8"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label class="m-0 p-0">차이값</label>
                        </b-input-group-text>
                        <b-form-input :number="true" v-touch:swipe.stop trim size="sm" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable" v-b-tooltip.focus title="이전에 저장한 값과 차이값 이상으로 달라야 저장합니다. 지정을 안하면 정수는 기본값 1을, 소수는 기본값 0.01을 사용합니다." :min="valueTypeList[value.type].title.diff" max="valueTypeList[value.type].max" v-model="value.diff" class="rounded-0 border-bottom-0 fontSizeDot8"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 border-bottom-0">
                          <label class="m-0 p-0">숨김</label>
                        </b-input-group-text>
                        <b-form-select required :options="sensorValueHideOptions" v-b-tooltip.focus title="이 값을 true로 지정하면 IoT 기기에서 화면에 측정된 값을 표시하지 않습니다." v-model="value.hide" class="rounded-0 border-bottom-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
                      </b-input-group>

                      <b-input-group size="sm">
                        <b-input-group-text slot="prepend" class="leftCellTitle rounded-0">
                          <label class="m-0 p-0">전송 여부</label>
                        </b-input-group-text>

                        <b-form-select v-if="sensor.lastValues == null" required :options="sensorValueHoldOptions" v-b-tooltip.focus title="이 값을 true로 지정하면 IoT 기기에서 데이터를 전송하지 않습니다." v-model="value.hold" class="rounded-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>

                        <b-form-input  v-touch:swipe.stop v-else-if="value.hold == true" trim size="sm" disabled="disabled" v-b-tooltip.focus title="이 값을 true로 지정하면 IoT 기기에서 데이터를 전송하지 않습니다."
                        readonly="readonly" required value="true(전송안함)" class="rounded-0 fontSizeDot8"/>

                        <b-form-input  v-touch:swipe.stop v-else trim size="sm" disabled="disabled" v-b-tooltip.focus title="이 값을 true로 지정하면 IoT 기기에서 데이터를 전송하지 않습니다."
                        readonly="readonly" required value="false(전송함)" class="rounded-0 fontSizeDot8"/>

                      </b-input-group>
                    </div>
                    <div style="order: 2;" class="mr-2 ml-2" v-if="(sensor.lastBook*1000 + sensor.lastIndex + 1) == 0">
                        <b-button type="button" size="sm" variant="secondary" style="width:100%;padding:2px;" class="mt-1" @click="upValue(sensor.name, index)" :disabled="doingBackup || index==0 || (sensor.lastBook*1000 + sensor.lastIndex + 1) > 0">
                          &uarr;
                        </b-button>
                        <b-button type="button" size="sm" variant="secondary" style="width:100%;padding:2px;" class="mt-1" @click="deleteValue(sensor.name, index)" :disabled="doingBackup || (sensor.lastBook*1000 + sensor.lastIndex + 1) > 0">
                          삭제
                        </b-button>
                        <b-button type="button" size="sm" variant="secondary" style="width:100%;padding:2px;" class="mt-1" @click="downValue(sensor.name, index)" :disabled="doingBackup || index == (sensor.values.length-1) || (sensor.lastBook*1000 + sensor.lastIndex + 1) > 0">
                          &darr;
                        </b-button>
                    </div>
                  </div>
                </div>


                <b-input-group class="mt-3 mb-3 ml-2" size="sm" v-if="isLoginUserPageUser && (sensor.lastBook*1000 + sensor.lastIndex + 1) == 0">
                  <b-input-group-text slot="prepend" class="leftCellTitle rounded-0 bg-warning-lighter border-warning-dark">
                    <label :for="'addValueSelect_' + sensor.name" class="m-0 p-0 font-weight-bold text-warning-dark">
                      값 추가
                    </label>
                  </b-input-group-text>
                  <b-form-select :options="predefinedValuesOptions" v-model="predefinedValuesOptionsSelected[sensor.name]" formnovalidate="formnovalidate" :id="'addValueSelect_' + sensor.name" @change="addValue(sensor.name)" class="bg-warning-lighter border-warning-dark mr-3" :disabled="doingBackup || !pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
                </b-input-group>

              </div>
            </div>
          </b-form>

        </b-collapse>
      </div>
    </div>


    <b-modal v-touch:swipe.stop size="lg" id="addSensorAction"
    tabindex="-1" title="[2/3] 센서 수정하기" static header-bg-variant="success" header-text-variant="light" footer-bg-variant="light" header-class="pt-2 pb-2 pr-3 mb-1" body-class="pt-1" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm" data-nextfocus="addDeviceDeviceName" no-close-on-backdrop no-close-on-esc no-stacking>
      <div v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable">
        <p class="m-0 mt-1 mr-2 gothic fontSize1Dot2" style="line-height: 160%;">
          다음은 현재 추가된 센서입니다. 해당 센서가 없거나 사용하지 않으면 X를 눌러 삭제해주세요.
        </p> 
        <div class="mt-2">
          <b-button-group class="p-1" size="md" v-for="sensor, index in sortedSensors" :key="index">
            <b-button :variant="(sensor.id == newlyAddedSensorId)? 'success': 'secondary'" class="pr-3 pl-3 pt-1 pb-1">{{sensor.name}} ({{sensor.title}})</b-button>
            <b-button :variant="(sensor.id == newlyAddedSensorId)? 'success': 'secondary'" @click="deleteSensor(sensor.name, $event)" :disabled="doingBackup" class="pr-2 pl-1 pt-1 pb-1">X</b-button>
          </b-button-group>
        </div>  
        <p class="m-0 mt-2 mr-2 gothic fontSize1Dot2" style="line-height: 160%;">
          팅커블 IoT 키트에 추가한 센서가 있으면 센서 종류를 선택하면 센서가 추가됩니다. 
        </p> 
        <b-form @submit.stop.prevent id="addSensorNewSensorForm" class="was-validated m-0 mt-2 mr-2 gothic fontSize1Dot2">
          <b-input-group size="md" class="mt-1">
            <b-input-group-text slot="prepend" class="leftCellTitleTiny text-success-dark border-success-dark bg-success-lighter">
              <label for="" class="m-0 p-0">센서 종류</label>
            </b-input-group-text>
            <b-form-select id="predefinedSensorsSelect" required :options="predefinedSensorsOptions" size="md" v-model="predefinedSensorsOptionsSelected.newSensor" @change="applyPredefinedSensor(true)" class="p-3 font-weight-bold border-success-dark bg-success-lighter" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
          </b-input-group>
        </b-form>
        <p class="m-0 mt-2 mr-2 gothic fontSize1Dot2" style="line-height: 160%;">
          센서 수정이 끝났으면 WiFi 설정으로 이동해주세요.
        </p> 
      </div>
      <template slot="modal-footer">
          <b-button type="button" size="md" class="pr-3 pl-3 pt-1 pb-1 fontSize1Dot1" @click="goSerialWifiConfig" variant="success" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable">
            WiFi 설정으로 이동하기
          </b-button>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="sensorsJsonFloat"
      tabindex="-1" title="센서설정파일 보기" static @show="modalShowFocus" data-nextfocus="saveSensorsConfigButton" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
        <b-textarea size="sm" rows="15" class="fontSizeDot9" v-model="sensorsJsonSourceText" readonly></b-textarea>
      <template slot="modal-footer">

        <b-button variant="primary" id="saveSensorsConfigButton" size="sm" @click="createSensorsJson" v-b-tooltip.hover title="다운로드 할 센서설정파일을 만듭니다.">
          다운로드 할 센서설정파일 만들기
        </b-button>
        <b-button v-if="sensorsJsonDownloadURL != null" variant="danger" size="sm" :href="sensorsJsonDownloadURL" download="sensors.json" v-b-tooltip.hover title="만든 센서설정파일을 다운로드 합니다.">
          만든 센서설정파일 다운로드
        </b-button>
        <b-button variant="secondary" size="sm" @click="hideModal('sensorsJsonFloat')">
          닫기
        </b-button>
      </template>
    </b-modal>


    <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="addNewSensorFloat" tabindex="-1" title="새로운 센서 추가하기" static @show="modalShowFocus" data-nextfocus="predefinedSensorsSelect" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
      <div>
        <b-input-group size="sm">
          <b-input-group-text slot="prepend" class="leftCellTitle text-warning-dark border-warning-dark bg-warning-lighter">
            <label for="" class="m-0 p-0 font-weight-bold">추가할 센서 선택</label>
          </b-input-group-text>
          <b-form-select id="predefinedSensorsSelect" :options="predefinedSensorsOptions" v-model="predefinedSensorsOptionsSelected.newSensor" @change="applyPredefinedSensor(false)" class="font-weight-bold border-warning-dark bg-warning-lighter text-warning-dark" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>
      </div>
      <p class="mt-2 mb-0 p-0 fontSizeDot9 gothic" style="line-height: 170%;">
        <b>추가할 센서의 종류</b>를 선택하면 미리 정의된 설정이 적용됩니다. <b>붉은 글씨는 센서가 추가된 뒤에 수정할 수 없습니다</b>.
        설정을 수정한 다음에
        <b-button variant="danger"  @click="addNewSensor" id="addNewSensorButton" size="sm" class="fontSizeDot8 pt-dot1 pb-dot1 m-0" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable || newSensor.name==''">
          센서 추가하기
        </b-button>를 누르면 센서가 추가됩니다.
      </p>
      <b-form @submit.stop.prevent id="newSensorForm" class="was-validated">
        <b-input-group size="sm" class="mt-2">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorName" class="m-0 p-0 fontSizeDot8">센서 이름</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop v-model="newSensor.name" trim size="sm" pattern="^[a-zA-Z_$][a-zA-Z_$0-9]{1,15}$" v-b-tooltip.focus title="센서의 이름. 데이터를 전송할 때 인자의 이름으로 사용합니다. 첫 글자는 _, 알파벳, 다른 글자는 숫자도 가능합니다. 최소 2글자, 최대 6글자입니다. !!! 센서 이름은 추가한 다음에 수정할 수 없습니다." minlength="2" maxlength="6" required id="newSensorName" class="font-weight-bold text-danger fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorTitle" class="m-0 p-0 fontSizeDot8">화면 제목</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="newSensorTitle" v-model="newSensor.title" trim size="sm" v-b-tooltip.focus title="화면할 표시될 센서의 이름입니다. 최소 2글자, 최대 16글자입니다." minlength="2" maxlength="16" required class="font-weight-bold fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorType" class="m-0 p-0 fontSizeDot8">센서 타입</label>
          </b-input-group-text>
          <b-form-select required :options="sensorTypeOptions" size="sm" v-b-tooltip.focus title="센서의 종류입니다." v-model="newSensor.type" disabled="disabled" id="newSensorType" class="font-weight-bold fontSizeDot8"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorRead" class="m-0 p-0 fontSizeDot8">읽기 간격</label>
          </b-input-group-text>
          <b-form-input :number="true" v-touch:swipe.stop id="newSensorRead" v-model="newSensor.read" trim size="sm" v-b-tooltip.focus title="IoT 기기에서 센서를 읽는 간격입니다. 단위는 1/1000초입니다. 지정하지 않으면 센서의 기본값을 사용합니다. 센서의 기본값은 센서마다 다릅니다. 0으로 지정하면 읽지 않습니다." type="number" min="0" class="font-weight-bold fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorUpdate" class="m-0 p-0 fontSizeDot8">전송 간격</label>
          </b-input-group-text>
          <b-form-input :number="true" v-touch:swipe.stop id="newSensorUpdate" v-model="newSensor.update" trim size="sm" v-b-tooltip.focus title="IoT 기기에서 읽은 값을 업로딩하는 간격입니다. 단위는 1/1000초입니다. 0 또는 60000 이상의 정수입니다. 지정하지 않으면 기기의 기본값을 사용하고, 0으로 지정하면 업로드하지 않습니다." pattern="^0|([6-9]\d\d\d\d)|([1-9]\d{5,})$" class="font-weight-bold fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorCategory" class="m-0 p-0 fontSizeDot8">센서 분류</label>
          </b-input-group-text>
          <b-form-select required  :options="sensorCategoryOptions" size="sm" v-b-tooltip.focus title="센서의 분류입니다. I2C, SERIAL, DIGITAL, ANALOG, ETC 중에 선택해주세요." v-model="newSensor.category"  :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable || newSensor.type !='CUSTOM'" id="newSensorCategory" class="font-weight-bold fontSizeDot8"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2" v-if="newSensor.category == 'digital' || newSensor.category == 'analog'">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorPin" class="m-0 p-0 fontSizeDot8">핀 번호</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="newSensorPin" v-model="newSensor.pin" trim size="sm" v-b-tooltip.focus title="센서가 사용하는 pin의 번호입니다." class="font-weight-bold fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2" v-if="newSensor.category == 'i2c'">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorAddress" class="m-0 p-0 fontSizeDot8">I2C 주소</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="newSensorAddress" v-model="newSensor.address" trim size="sm" v-b-tooltip.focus title="센서가 I2C 통신에 사용하는 주소입니다." class="font-weight-bold fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2" v-if="newSensor.category == 'serial'">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorRx"  class="m-0 p-0 fontSizeDot8">RX 핀</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="newSensorRx" v-model="newSensor.rx" trim size="sm" v-b-tooltip.focus title="센서가 시리얼 통신에 사용하는 RX 핀의 이름입니다." class="font-weight-bold fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-dot2" v-if="newSensor.category == 'serial'">
          <b-input-group-text slot="prepend" class="leftCellTitleTiny">
            <label for="newSensorTx" class="m-0 p-0 fontSizeDot8">TX 핀</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="newSensorTx" v-model="newSensor.tx" trim size="sm" v-b-tooltip.focus title="센서가 시리얼 통신에 사용하는 TX 핀의 이름입니다." class="font-weight-bold fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
        </b-input-group>

        <div class="mt-1 p-2 pl-3" style="border: 1px solid #ced4da; background: #f9fcff;">
          <div v-for="(value, position) in newSensor.values" :key="position" style="display: flex;">
            <div style="order: 1; flex-grow: 1;">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0" style="width: 5rem;">
                  <label class="m-0 p-0 fontSizeDot8">값의 이름</label>
                </b-input-group-text>
                <b-form-input  v-touch:swipe.stop trim size="sm" v-b-tooltip.focus title="데이터의 이름입니다. 데이터를 전송할 때 키로 사용합니다. 이름은 최소 2글자, 최대 6글자입니다. 첫 글자는 _, 알파벳, 다른 글자는 숫자도 가능합니다." pattern="^[a-zA-Z_$][a-zA-Z_$0-9]{1,15}$" minlength="2" maxlength="6" required :id="'newSensorValueName' + position" v-model="value.name" class="font-weight-bold rounded-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0 fontSizeDot8">값의 제목</label>
                </b-input-group-text>
                <b-form-input  v-touch:swipe.stop trim size="sm" v-b-tooltip.focus title="화면에 표시될 데이터의 이름입니다. 최소 2글자, 최대 16글자입니다. 한글도 가능합니다." minlength="2" maxlength="16" required v-model="value.title" class="font-weight-bold rounded-0 rounded-0 border-top-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0 fontSizeDot8">값의 형식</label>
                </b-input-group-text>
                <b-form-select required :options="sensorValueTypeOptions" v-b-tooltip.focus title="데이터의 형식입니다." v-model="value.type" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable || newSensor.type != 'CUSTOM'" class="font-weight-bold rounded-0 rounded-0 border-top-0 fontSizeDot8"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0 fontSizeDot8">값의 단위</label>
                </b-input-group-text>
                <b-form-input  v-touch:swipe.stop trim size="sm" v-b-tooltip.focus title="값의 단위입니다. 최대 4글자입니다." maxlength="4" v-model="value.unit" class="font-weight-bold rounded-0 rounded-0 border-top-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0 fontSizeDot8">최솟값</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop trim size="sm" v-b-tooltip.focus :title="valueTypeList[value.type].title"  :number="true" :min="valueTypeList[value.type].title.min" :max="valueTypeList[value.type].title.max" v-model="value.min" class="font-weight-bold rounded-0 rounded-0 border-top-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0 fontSizeDot8">최댓값</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop trim size="sm" v-b-tooltip.focus :title="valueTypeList[value.type].title"  :number="true" :min="valueTypeList[value.type].title.min" :max="valueTypeList[value.type].title.max" v-model="value.max" class="font-weight-bold rounded-0 rounded-0 border-top-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>


              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0 fontSizeDot8">차이값</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop trim size="sm" v-b-tooltip.focus title="이전에 저장한 값과 차이값 이상으로 달라야 저장합니다. 지정을 안하면 정수는 기본값 1을, 소수는 기본값 0.01을 사용합니다." :number="true" :min="valueTypeList[value.type].title.min" :max="valueTypeList[value.type].title.max" v-model="value.diff" class="font-weight-bold rounded-0 rounded-0 border-top-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0">숨김</label>
                </b-input-group-text>
                <b-form-select required :options="sensorValueHideOptions" v-b-tooltip.focus title="이 값을 true로 지정하면 IoT 기기의 화면에 측정된 값을 표시하지 않습니다." v-model="value.hide" class="font-weight-bold rounded-0 rounded-0 border-top-0 fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-0">
                <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-top-0" style="width: 5rem;">
                  <label class="m-0 p-0">전송안함</label>
                </b-input-group-text>
                <b-form-select required :options="sensorValueHoldOptions" v-b-tooltip.focus title="이 값을 true로 지정하면 IoT 기기에서 데이터를 전송하지 않습니다. 데이터가 저장된 이후에는 수정할 수 없습니다." v-model="value.hold" class="font-weight-bold rounded-0 rounded-0 border-top-0 text-danger fontSizeDot8" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
              </b-input-group>
            </div>
            <div style="order: 2" class="ml-2">
              <b-button type="button" size="sm" variant="light" class="w-100 border-secondary text-danger font-weight-bold mt-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot9 rounded-0" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable || position == 0" @click="upNewSensorValue(position)">
                  &uarr;
              </b-button>
              <b-button type="button" size="sm" variant="light" class="w-100 border-secondary text-danger font-weight-bold mt-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot9 rounded-0" @click="deleteNewSensorValue(position)" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable">
                삭제
              </b-button>
              <b-button type="button" size="sm" variant="light" class="w-100 border-secondary text-danger font-weight-bold mt-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot9 rounded-0" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable || position == (newSensor.values.length-1)" @click="downNewSensorValue(position)">
                &darr;
              </b-button>
            </div>
          </div>
          <div>
            <b-input-group size="sm" class="mt-3">
              <b-input-group-text slot="prepend" class="leftCellTitleTiny rounded-0 border-warning-dark bg-warning-lighter" style="width: 5rem;">
                <label for="newSensorNewValueType" class="m-0 p-0 fontSizeDot8 font-weight-bold text-warning-dark">값 추가</label>
              </b-input-group-text>
              <b-form-select id="newSensorNewValueType" :options="predefinedValuesOptions" v-model="predefinedValuesOptionsSelected.newSensor" formnovalidate="formnovalidate"  class="rounded-0 font-weight-bold fontSizeDot8 border-warning-dark bg-warning-lighter text-warning-dark" @change="addNewValue" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable"/>
            </b-input-group>
          </div>
        </div>
      </b-form>
      <template slot="modal-footer">
        <b-button variant="danger" size="sm" @click="hideModal('addNewSensorFloat')">
          닫기
        </b-button>
        <b-button variant="secondary" id="addNewSensorButton" size="sm" @click="addNewSensor" :disabled="!pageBinded || pageDevice.disabled || !isLoginUserPageItemWritable">
          센서 추가하기
        </b-button>
      </template>
    </b-modal>

    <b-toast id="backupSensorDataToast" class="b-toaster" title="센서 데이터 백업하는 중..." variant="primary" no-auto-hide>
      <p>
        <b-spinner small type="grow" variant="danger" class="mr-1" v-if="doingBackup"></b-spinner>
        <span class="font-weight-bold text-danger">{{ backupSensorDataMessage }}</span>
        <b-spinner small type="grow" variant="danger" class="ml-1" v-if="doingBackup"></b-spinner>
      </p>
    </b-toast>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"

import deviceTabs from "@/components/device/deviceTabs.vue"

// import { merge } from "lodash";

let doNotUse = {
  acode: true,
  sensor: true,
  dt: true,
  dtstr: true,
  json: true,
  read: true,
  write: true,
  hide: true,
  hold: true,
  max: true,
  min: true,
  category: true,
  title: true,
  update: true,
  value: true,
  val: true,
  pin: true,
  rx: true,
  tx: true,
  address: true,
  param: true,
  type: true
}

export default {
  name: "deviceSensors",
  mixins: [uiUtil, mapUtil, user],
  props: {
    pageUser: {
      type: Object,
      default: null
    },
    pageDevice: {
      type: Object,
      default: null
    },
    pageBinded: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ""
    },
  },
  components: {
    deviceTabs,
  },
  data: function() {
    return {


      backupUri: {},
      doingBackup: false,
      backupSensorDataMessage: "",
      showDeleteButton: {},
      newlyAddedSensorId: "",
      predefinedValuesOptions: [],
      predefinedValuesOptionsSelected: {
        newSensor: null
      },
      sensorsJsonDownloadURL: null,
      valueType : {
        "BOOL_VAL":2,
        "INT_VAL":3,
        "UNSIGNED_INT_VAL":4,
        "LONG_VAL":5,
        "UNSIGNED_LONG_VAL":6,
        "FLOAT_VAL":7
      },
      sensorType : {
        "CUSTOM": 2,
        "BME280": 3,
        "BH1750": 4,
        "DIGITAL": 5,
        "BUTTON": 6,
        "S8": 7,
        "PMS": 8,
        "ANALOG": 9,
        "INA219": 10,
        "DHT22": 11,
        "TCS34725": 12,
        "BMP280": 13,
        "BME680": 14,
        "PMSST": 15,
        "CCS811": 16,
        "INA3221": 17,
        "VEML6070": 18,
        "MAX30100": 19,
        "MPU6050": 20,
        "MAX4466": 21,
        "LM393": 22,
        "VL53L0X": 23,
        "PMSF": 24,
        "PMSTF": 25,
        "DS18B20": 27,
        "TDS": 29,
        "LSM303": 33,
        "LSM303F": 34,
      },
      predefinedSensorsOptions: [
        {
          text: "CUSTOM 센서",
          value: {
            title: "CUSTOM 센서",
            type: "CUSTOM",
            category: "etc",
            values: []
          }
        },
        {
          text: "디지털 센서 (Digital)",
          value: {
            name: "digital",
            title: "디지털 센서",
            type: "DIGITAL",
            category: "digital",
            pin: "D8",
            values: [
              {
                text: "digital",
                value: {
                  name: "digital",
                  title: "digital",
                  type: "BOOL_VAL",
                  hide: false,
                  hold: false
                }
              }
            ],
          },
        },
        {
          text: "수온 센서 (DS18B20)",
          value: {
            name: "ds18b20",
            title: "수온 센서",
            type: "DS18B20",
            category: "digital",
            pin: "D8",
            values: [
              {
                text: "wtemp",
                value: {
                  name: "wtemp",
                  title: "수온",
                  type: "FLOAT_VAL",
                  unit: "*C",
                  hide: false,
                  hold: false
                }
              }
            ],
          },
        },
        {
          text: "아날로그 센서 (Analog)",
          value: {
            name: "analog",
            title: "아날로그 센서",
            type: "ANALOG",
            category: "analog",
            pin: "A0",
            values: [
              {
                text: "analog",
                value: {
                  name: "analog",
                  title: "analog",
                  type: "UNSIGNED_INT_VAL",
                  hide: false,
                  hold: false,
                }
              }
            ],
          },
        },
        {
          text: "TDS 센서 (TDS)",
          value: {
            name: "TDS",
            title: "TDS 센서",
            type: "TDS",
            category: "analog",
            pin: "A0",
            values: [
              {
                text: "analog",
                value: {
                  name: "analog",
                  title: "analog",
                  type: "UNSIGNED_INT_VAL",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "TDS",
                value: {
                  name: "TDS",
                  title: "TDS",
                  type: "FLOAT_VAL",
                  unit: "ppm",
                  hide: false,
                  hold: false,
                }
              }  
            ],
          },
        },
        {
          text: "버튼 센서 (BUTTON)",
          value: {
            title: "버튼 센서",
            name: "button",
            type: "BUTTON",
            category: "digital",
            pin: "D7",
            update: 0,
            values: [
              {
                text: "button",
                value: {
                  name: "button",
                  title: "button",
                  type: "BOOL_VAL",
                  hide: true,
                  hold: true
                }
              }
            ],
          },
        },
        {
          text: "조도센서 (BH1750)",
          value: {
            name: "bh1750",
            title: "조도 센서",
            type: "BH1750",
            category: "i2c",
            values: [
              {
                text: "light",
                value: {
                  name: "light",
                  title: "illuminance",
                  type: "UNSIGNED_LONG_VAL",
                  unit: "lux",
                  hide: false,
                  hold: false,
                }
              }
            ],
          },
        },
        {
          text: "온도/습도/기압 센서 (BME280)",
          value: {
            name: "bme280",
            title: "온도/습도/기압 센서",
            type: "BME280",
            category: "i2c",
            values: [
              {
                text: "temp",
                value: {
                  name: "temp",
                  title: "온도",
                  type: "FLOAT_VAL",
                  unit: "*C",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "baro",
                value: {
                  name: "baro",
                  title: "기압",
                  type: "FLOAT_VAL",
                  unit: "KPa",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "humi",
                value: {
                  name: "humi",
                  title: "습도",
                  type: "FLOAT_VAL",
                  unit: "%",
                  hide: false,
                  hold: false,
                }
              }
            ],
          },
        },
        {
          text: "온도/습도/기압/공기질 센서 (BME680)",
          value: {
            name: "bme680",
            title: "온도/습도/기압/공기질 센서",
            type: "BME680",
            category: "i2c",
            values: [
              {
                text: "temp",
                value: {
                  name: "temp",
                  title: "온도",
                  type: "FLOAT_VAL",
                  unit: "*C",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "baro",
                value: {
                  name: "baro",
                  title: "기압",
                  type: "FLOAT_VAL",
                  unit: "KPa",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "humi",
                value: {
                  name: "humi",
                  title: "습도",
                  type: "FLOAT_VAL",
                  unit: "%",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "gas",
                value: {
                  name: "gas",
                  title: "가스",
                  type: "FLOAT_VAL",
                  unit: "Ohm",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "IAQ", // 0-500
                value: {
                  name: "IAQ",
                  title: "IAQ",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "sIAQ", // 0-500
                value: {
                  name: "sIAQ",
                  title: "staticIAQ",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "stat", // 0-500
                value: {
                  name: "stat",
                  title: "status",
                  type: "INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "eCO2", // 400 ~ 4000
                value: {
                  name: "eCO2",
                  title: "eCO2",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ppm",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "bVOC", // 0.3~
                value: {
                  name: "bVOC",
                  title: "breathVOC",
                  type: "FLOAT_VAL",
                  unit: "ppm",
                  hide: false,
                  hold: false,
                }
              },
            ],
          },
        },
        /*
        {
          text: "휘발성 유기화합물 센서 (CCS811)",
          value: {
            name: "ccs811",
            title: "VOC 센서",
            type: "CCS811",
            category: "i2c",
            values: [
              {
                text: "eCO2",
                value: {
                  name: "eCO2",
                  title: "eCO2",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ppm",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "TVOC",
                value: {
                  name: "TVOC",
                  title: "TVOC",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ppb",
                  hide: false,
                  hold: false,
                }
              },
            ],
          },
        },
        */
        {
          text: "CO2 센서 (S8, K30)",
          value: {
            title: "C02 센서",
            name: "co2",
            type: "S8",
            category: "serial",
            values: [
              {
                text: "co2",
                value: {
                  name: "co2",
                  title: "CO2",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ppm",
                  hide: false,
                  hold: false,
                }
              }
            ],
          },
        },
        {
          text: "미세먼지 센서 (PMS5003, PMS7003)",
          value: {
            name: "pms",
            title: "미세먼지 센서",
            type: "PMS",
            category: "serial",
            values: [
              {
                text: "pm1",
                value: {
                  name: "pm1",
                  title: "표준 PM1",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm2_5",
                value: {
                  name: "pm2_5",
                  title: "표준 PM2.5",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm10",
                value: {
                  name: "pm10",
                  title: "표준 PM10",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              }
            ]
          }
        },
        {
          text: "미세먼지 센서 (PMS5003, PMS7003,...) Full(beta)",
          value: {
            name: "pms",
            title: "미세먼지 센서",
            type: "PMSF",
            category: "serial",
            values: [
              {
                text: "pm1",
                value: {
                  name: "pm1",
                  title: "표준 PM1",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm2_5",
                value: {
                  name: "pm2_5",
                  title: "표준 PM2.5",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm10",
                value: {
                  name: "pm10",
                  title: "표준 PM10",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm1e",
                value: {
                  name: "pm1e",
                  title: "측정 PM1",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "pm2_5e",
                value: {
                  name: "pm2_5e",
                  title: "측정 PM2.5",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "pm10e",
                value: {
                  name: "pm10e",
                  title: "측정 PM10",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p3",
                value: {
                  name: "p3",
                  title: "0.3um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p5",
                value: {
                  name: "p5",
                  title: "0.5um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p10",
                value: {
                  name: "p10",
                  title: "1um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p25",
                value: {
                  name: "p25",
                  title: "2.5um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p50",
                value: {
                  name: "p50",
                  title: "5um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p100",
                value: {
                  name: "p100",
                  title: "10um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              }
            ]
          }
        },
        {
          text: "미세먼지/포름알데히드 센서 (PMS5003ST)",
          value: {
            name: "pmsst",
            title: "미세먼지/포름알데히드 센서",
            type: "PMSST",
            category: "serial",
            values: [
              {
                text: "pm1",
                value: {
                  name: "pm1",
                  title: "표준 PM1",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm2_5",
                value: {
                  name: "pm2_5",
                  title: "표준 PM2.5",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm10",
                value: {
                  name: "pm10",
                  title: "표준 PM10",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "HCHO",
                value: {
                  name: "HCHO",
                  title: "포름알데히드",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "temp",
                value: {
                  name: "temp",
                  title: "온도",
                  type: "FLOAT_VAL",
                  unit: "*C",
                  hide: true,
                  hold: false,
                  diff: 0.1,
                }
              },
              {
                text: "humi",
                value: {
                  name: "humi",
                  title: "습도",
                  type: "FLOAT_VAL",
                  unit: "%",
                  hide: true,
                  hold: false,
                  diff: 0.1,
                }
              }
            ]
          }
        },
        {
          text: "미세먼지/포름알데히드 센서 (PMS5003ST) Full(beta)",
          value: {
            name: "pmsstf",
            title: "미세먼지/포름알데히드 센서",
            type: "PMSTF",
            category: "serial",
            values: [
              {
                text: "pm1",
                value: {
                  name: "pm1",
                  title: "표준 PM1",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm2_5",
                value: {
                  name: "pm2_5",
                  title: "표준 PM2.5",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm10",
                value: {
                  name: "pm10",
                  title: "표준 PM10",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "pm1e",
                value: {
                  name: "pm1e",
                  title: "측정 PM1",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "pm2_5e",
                value: {
                  name: "pm2_5e",
                  title: "측정 PM2.5",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "pm10e",
                value: {
                  name: "pm10e",
                  title: "측정 PM10",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p3",
                value: {
                  name: "p3",
                  title: "0.3um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p5",
                value: {
                  name: "p5",
                  title: "0.5um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p10",
                value: {
                  name: "p10",
                  title: "1um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p25",
                value: {
                  name: "p25",
                  title: "2.5um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p50",
                value: {
                  name: "p50",
                  title: "5um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "p100",
                value: {
                  name: "p100",
                  title: "10um 먼지",
                  type: "UNSIGNED_INT_VAL",
                  unit: "/dL",
                  hide: true,
                  hold: false
                }
              },
              {
                text: "HCHO",
                value: {
                  name: "HCHO",
                  title: "포름알데히드",
                  type: "UNSIGNED_INT_VAL",
                  unit: "ug",
                  hide: false,
                  hold: false
                }
              },
              {
                text: "temp",
                value: {
                  name: "temp",
                  title: "온도",
                  type: "FLOAT_VAL",
                  unit: "*C",
                  hide: true,
                  hold: false,
                  diff: 0.1,
                }
              },
              {
                text: "humi",
                value: {
                  name: "humi",
                  title: "습도",
                  type: "FLOAT_VAL",
                  unit: "%",
                  hide: true,
                  hold: false,
                  diff: 0.1,
                }
              }
            ]
          }
        },
        {
          text: "전류전압 센서 (INA219)",
          value: {
            name: "ina219",
            title: "전류전압 센서",
            type: "INA219",
            category: "i2c",
            values: [
              {
                text: "curr",
                value: {
                  name: "curr",
                  title: "전류",
                  type: "FLOAT_VAL",
                  unit: "mA",
                  hide: false,
                  hold: false,
                  diff: 0.01,
                }
              },
              {
                text: "volt",
                value: {
                  name: "volt",
                  title: "전압",
                  type: "FLOAT_VAL",
                  unit: "V",
                  hide: false,
                  hold: false,
                  diff: 0.01,
                }
              }
            ],
          },
        },
        {
          text: "색깔 센서 (TCS34725)",
          value: {
            name: "t34725",
            title: "색깔 센서",
            type: "TCS34725",
            category: "i2c",
            values: [
              {
                text: "temp",
                value: {
                  name: "temp",
                  title: "색온도",
                  type: "UNSIGNED_INT_VAL",
                  unit: "K",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "light",
                value: {
                  name: "light",
                  title: "조도",
                  type: "UNSIGNED_INT_VAL",
                  unit: "lux",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "clear",
                value: {
                  name: "clear",
                  title: "투명",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "red",
                value: {
                  name: "red",
                  title: "빨강",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "green",
                value: {
                  name: "green",
                  title: "녹색",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "blue",
                value: {
                  name: "blue",
                  title: "파랑",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              }
            ],
          },
        },
        {
          text: "UV 센서 (VEML6070)",
          value: {
            name: "v6070",
            title: "UV 센서",
            type: "VEML6070",
            category: "i2c",
            values: [
              {
                text: "uvVal",
                value: {
                  name: "uvVal",
                  title: "측정값",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              },
              {
                text: "uvIdx",
                value: {
                  name: "uvIdx",
                  title: "UV인덱스",
                  type: "FLOAT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                  diff: 0.01,
                }
              },
              {
                text: "uvLvl",
                value: {
                  name: "uvLvl",
                  title: "UV레벨",
                  type: "UNSIGNED_INT_VAL",
                  unit: "",
                  hide: false,
                  hold: false,
                }
              }
            ],
          },
        },
        
        {
          text: "GY302 센서 (LSM303)",
          value: {
            name: "compas",
            title: "LSM303 센서",
            type: "LSM303",
            category: "i2c",
            values: [
              {
                text: "head",
                value: {
                  name: "head",
                  title: "방향",
                  type: "FLOAT_VAL",
                  unit: "*",
                  diff: 0.01,
                  hide: false,
                  hold: false,
                }
              }
            ],
          },
        },


      ]
      ,
      predefinedSensorsOptionsSelected: {
        newSensor: null
      },

      sensorValueHideOptions: [
        {  value: false, text: "표시함(false)" },
        {  value: true, text: "표시안함(true)" }
      ],

      sensorValueHoldOptions: [
        {  value: false, text: "전송함(false)" },
        {  value: true, text: "전송안함(true)" }
      ],

      sensorValueTypeOptions: [
        {  value: "BOOL_VAL", text: "bool (0 또는 1)" },
        {  value: "INT_VAL", text: "short int (-32768 ~ 32767)" },
        {  value: "UNSIGNED_INT_VAL", text: "unsigned short int (0 ~ 65535)" },
        {  value: "LONG_VAL", text: "long int (-2147483648~2147483647)" },
        {  value: "UNSIGNED_LONG_VAL", text: "unsigned long int (0 ~ 4294967295)" },
        {  value: "FLOAT_VAL", text: "float (부정확. -3.4028235e+38~3.4028235e+38)" },
      ],

      sensorCategoryOptions: [
        { value: "i2c", text: "I2C" },
        { value: "digital", text: "DIGITAL" },
        { value: "analog", text: "ANALOG" },
        { value: "serial", text: "SERIAL" },
        { value: "etc", text: "ETC" }
      ],

      sensorDisabledOptions: [
        { value: false, text: "사용" },
        { value: true, text: "사용 중지" }
      ],

      sensorTypeOptions: [
        { value: "CUSTOM", text: "맞춤형 센서 (CUSTOM)" },
        { value: "DIGITAL", text: "디지털 센서 (Digital)" },
        { value: "ANALOG", text: "아날로그 센서 (Analog)" },
        { value: "BUTTON", text: "버튼 센서 (BUTTON)" },
        { value: "BH1750", text: "조도센서 (BH1750, GY30, GY302)" },
        { value: "BME280", text: "온도/습도/기압 센서(BME280)" },
        { value: "BME680", text: "온도/습도/기압/공기질 센서(BME680)" },
        { value: "S8", text: "CO2 센서 (S8, K30)" },
        { value: "PMS", text: "미세먼지 센서 (PMS)" },
        { value: "PMSF", text: "미세먼지 센서 (PMS) Full (beta)" },
        { value: "PMSST", text: "미세먼지/포름알데히드 센서 (PMS5003ST)" },
        { value: "PMSSTF", text: "미세먼지/포름알데히드 센서 (PMS5003ST) Full (beta)" },
        { value: "INA219", text: "전류전압 센서 (INA219)" },
        { value: "TCS34725", text: "색깔 센서 (TCS34725)" },
        { value: "VEML6070", text: "UV 센서 (VEML6070)" },
        { value: "LSM303", text: "GY302 센서 (LSM303)" },
        
        /*
        { value: "CCS811", text: "휘발성 유기화합물 센서(CCS811)" },
        */
      ],

      valueTypeList: {
        "INT_VAL": {
          title: "2바이트 정수입니다. 최솟값은 -32768입니다. 최댓값은 32767입니다.",
          min: -32768,
          max: 32767
        },
        "UNSIGNED_INT_VAL": {
          title: "2바이트 정수입니다. 최솟값은 0입니다. 최댓값은 65535입니다.",
          min: 0,
          max: 65535
        },
        "LONG_VAL": {
          title: "4바이트 정수입니다. 최솟값은 -2147483648입니다. 최댓값은 2147483647입니다.",
          min: -2147483648,
          max: 2147483647
        },
        "UNSIGNED_LONG_VAL": {
          title: "4바이트 정수입니다. 최솟값은 0입니다. 최댓값은 4294967295입니다.",
          min: 0,
          max: 4294967295
        },
        "FLOAT_VAL": {
          title: "4바이트 실수입니다. 부정확합니다. 최솟값은 -3.4028235e+38입니다. 최댓값은 3.4028235e+38입니다.",
          min: Number.MAX_VALUE,
          max: Number.MIN_VALUE
        },
        "BOOL_VAL" : {
          title: "1바이트 부울 값입니다. 최솟값은 0입니다. 최댓값은 1입니다.",
          min: 0,
          max: 1
        }
      },

      predefinedValues: [
        {
          // 0
          text: "bool (0 또는 1)",
          value: {
            type: "BOOL_VAL",
            max: 1,
            min: 0,
            diff: 1
          }
        },
        {
          // 1
          text: "short int (-32768 ~ 32767)",
          value: {
            type: "INT_VAL",
            max: 32767,
            min: -32768,
            diff: 1
          }
        },
        {
          // 2
          text: "unsigned short int (0 ~ 65535)",
          value: {
            type: "UNSIGNED_INT_VAL",
            max: 65535,
            min: 0,
            diff: 1
          }
        },
        {
          // 3
          text: "long int (-2147483648 ~ 2147483647)",
          value: {
            type: "LONG_VAL",
            max: 2147483647,
            min: -2147483648,
            diff: 1
          }
        },
        {
          // 4
          text: "unsigned long int (0 ~ 4294967295)",
          value: {
            type: "UNSIGNED_LONG_VAL",
            max: 4294967295,
            min: 0,
            diff: 1
          }
        },
        {
          // 5
          text: "float (부정확. -3.4028235e+38 ~ 3.4028235e+38)",
          value: {
            type: "FLOAT_VAL",
            max:  3.4028235e+38,
            min: -3.4028235e+38,
            diff: 0.01
          }
        }
      ],

      newSensor: {
        name: "",
        title: "CUSTOM 센서",
        type: "CUSTOM",
        read: "",
        update: "",
        category: "etc",
        rx: "",
        tx: "",
        pin: "",
        address: "",
        values: []
      },
      sensorsCollapsed: {}
    }
  },
  created: function() {
    firebase.auth().onAuthStateChanged(() => {
      if(firebase.auth().currentUser != null) {
        this.predefinedValuesOptions = this.predefinedValues;
      }
      for(let item in this.pageDevice.sensors) {
        this.predefinedValuesOptionsSelected[item] = null;
      }
    })
  },

  mounted: function() {

    if(this.action == "addSensor") {
      this.showModal("addSensorAction");
    }
    else {
      let toastNotShown = true
      for(const prop in this.pageDevice.sensors) {
        this.$set(this.sensorsCollapsed, prop, false);
        if(typeof(this.pageDevice.sensors[prop].disabled) == "undefined") {
          if(toastNotShown) {
            this.makeToast("warning", "센서 설정 업데이트 필요", "[1] 센서 설정이 오래되었습니다. 센서 설정을 살펴보신 후에 설정 저장을 눌러주세요.", {"autoHideDelay": 10000})
            toastNotShown = false
          }
          this.pageDevice.sensors[prop].disabled = false
        }

        // co2
        if(this.pageDevice.sensors[prop].name.indexOf("co2") == 0) {
          if(typeof(this.pageDevice.sensors[prop].type) == "undefined") {
            if(toastNotShown) {
              this.makeToast("warning", "센서 설정 업데이트 필요", "[2] 센서 설정이 오래되었습니다. 센서 설정을 살펴보신 후에 설정 저장을 눌러주세요.", {"autoHideDelay": 10000})
              toastNotShown = false
            }
            this.pageDevice.sensors[prop].type = "S8";
          }
          if(typeof(this.pageDevice.sensors[prop].category) == "undefined") {
            if(toastNotShown) {
              this.makeToast("warning", "센서 설정 업데이트 필요", "[3] 센서 설정이 오래되었습니다.  센서 설정을 살펴보신 후에 설정 저장을 눌러주세요.", {"autoHideDelay": 10000})
              toastNotShown = false
            }
            this.pageDevice.sensors[prop].category="serial";
          }
          this.pageDevice.sensors[prop].values.forEach(value=>{
            if(value.type=="number") {
              value.type = "UNSIGNED_INT_VAL"
            }
            else if(value.type =="string") {
              this.makeToast("danger", "값의 형식 에러", "이제 값의 형식으로 string을 더 이상 사용할 수 없습니다. string 형식을 변경해주시기 바랍니다.")
            }
            if(typeof(value.hide) == "undefined") {
              value.hide = false;
            }
            if(typeof(value.hold) == "undefined") value.hold = false;
          })
        }
        // gy3
        // bh1750
        else if(this.pageDevice.sensors[prop].name.indexOf("bh1750") == 0 || this.pageDevice.sensors[prop].name.indexOf("gy3") == 0) {
          if(typeof(this.pageDevice.sensors[prop].type) == "undefined") {
            if(toastNotShown) {
              this.makeToast("warning", "센서 설정 업데이트 필요", "[4] 센서 설정이 오래되었습니다.  센서 설정을 살펴보신 후에 설정 저장을 눌러주세요.", {"autoHideDelay": 10000})
              toastNotShown = false
            }
            this.pageDevice.sensors[prop].type="BH1750";
          }
          if(typeof(this.pageDevice.sensors[prop].category) == "undefined") {
            this.pageDevice.sensors[prop].category="i2c";
          }

          this.pageDevice.sensors[prop].values.forEach(value=>{
            if(value.type=="number") {
              value.type = "LONG_VAL"
            }
            else if(value.type =="string") {
              this.makeToast("danger", "값의 형식 에러", "이제 값의 형식으로 string을 더 이상 사용할 수 없습니다. 형식이 string인 값은 변경해주시기 바랍니다.")
            }
            if(typeof(value.hide) == "undefined") value.hide = false;
            if(typeof(value.hold) == "undefined") value.hold = false;
          })

        }
        // bme2
        else if(this.pageDevice.sensors[prop].name.indexOf("bme2") == 0) {
          if(typeof(this.pageDevice.sensors[prop].type) == "undefined") {
            if(toastNotShown) {
              this.makeToast("warning", "센서 설정 업데이트 필요", "[5] 센서 설정이 오래되었습니다.  센서 설정을 살펴보신 후에 설정 저장을 눌러주세요.", {"autoHideDelay": 10000})
              toastNotShown = false
            }
            this.pageDevice.sensors[prop].type="BME280";
          }
          if(typeof(this.pageDevice.sensors[prop].category) == "undefined") {
            this.pageDevice.sensors[prop].category="i2c";
          }

          this.pageDevice.sensors[prop].values.forEach(value=>{
            if(value.type=="number") {
              value.type = "FLOAT_VAL"
            }
            else if(value.type =="string") {
              this.makeToast("danger", "값의 형식 에러", "이제 값의 형식으로 string을 더 이상 사용할 수 없습니다. 형식이 string인 값은 변경해주시기 바랍니다.")
            }
            if(typeof(value.hide) == "undefined") value.hide = false;
            if(typeof(value.hold) == "undefined") value.hold = false;
          })
        }
        //pms
        else if(this.pageDevice.sensors[prop].name.indexOf("pms") == 0) {
          if(typeof(this.pageDevice.sensors[prop].type) == "undefined") {
            this.pageDevice.sensors[prop].type="PMS";
          }
          if(typeof(this.pageDevice.sensors[prop].category) == "undefined") {
            this.pageDevice.sensors[prop].category="serial";
          }

          this.pageDevice.sensors[prop].values.forEach(value=>{
            if(value.type=="number") {
              value.type = "LONG_VAL"
            }
            else if(value.type =="string") {
              this.makeToast("danger", "값의 형식 에러", "이제 값의 형식으로 string을 더 이상 사용할 수 없습니다. 형식이 string인 값은 변경해주시기 바랍니다.")
            }
            if(typeof(value.hide) == "undefined") value.hide = false;
            if(typeof(value.hold) == "undefined") value.hold = false;
          })
        }
        // analog
        else if(this.pageDevice.sensors[prop].name.indexOf("analog") == 0) {
          if(typeof(this.pageDevice.sensors[prop].type) == "undefined") {
            if(toastNotShown) {
              this.makeToast("warning", "센서 설정 업데이트 필요", "[6] 센서 설정이 오래되었습니다. 센서 설정을 살펴보신 후에 설정 저장을 눌러주세요.", {"autoHideDelay": 10000})
              toastNotShown = false
            }
            this.pageDevice.sensors[prop].type="ANALOG";
          }
          if(typeof(this.pageDevice.sensors[prop].category) == "undefined") {
            this.pageDevice.sensors[prop].category="analog";
          }

          this.pageDevice.sensors[prop].values.forEach(value=>{
            if(value.type=="number") {
              value.type = "UNSIGNED_INT_VAL"
            }
            else if(value.type =="string") {
              this.makeToast("danger", "값의 형식 에러", "이제 값의 형식으로 string을 더 이상 사용할 수 없습니다. 형식이 string인 값은 변경해주시기 바랍니다.")
            }
            if(typeof(value.hide) == "undefined") value.hide = false;
            if(typeof(value.hold) == "undefined") value.hold = false;
          })
        }
        // dht
        else if(this.pageDevice.sensors[prop].name.indexOf("dht") == 0) {
          if(typeof(this.pageDevice.sensors[prop].type) == "undefined") {
            if(toastNotShown) {
              this.makeToast("warning", "센서 설정 업데이트 필요", "[7] 센서 설정이 오래되었습니다. 센서 설정을 살펴보신 후에 설정 저장을 눌러주세요.", {"autoHideDelay": 10000})
              toastNotShown = false
            }
            this.pageDevice.sensors[prop].type="DHT22";
          }
          if(typeof(this.pageDevice.sensors[prop].category) == "undefined") {
            this.pageDevice.sensors[prop].category="digital";
          }

          this.pageDevice.sensors[prop].values.forEach(value=>{
            if(value.type=="number") {
              value.type = "FLOAT_VAL"
            }
            else if(value.type =="string") {
              this.makeToast("danger", "값의 형식 에러", "이제 값의 형식으로 string을 더 이상 사용할 수 없습니다. 형식이 string인 값은 변경해주시기 바랍니다.")
            }
            if(typeof(value.hide) == "undefined") value.hide = false;
            if(typeof(value.hold) == "undefined") value.hold = false;
          })
        }
        else {
          if(typeof(this.pageDevice.sensors[prop].type) == "undefined") {
            this.pageDevice.sensors[prop].type="CUSTOM";
          }
          if(typeof(this.pageDevice.sensors[prop].category) == "undefined") {
            this.pageDevice.sensors[prop].category="etc";
          }
          this.pageDevice.sensors[prop].values.forEach(value=>{
            if(value.type=="number") {
              value.type = "FLOAT_VAL"
            }
            else if(value.type =="int") {
              value.type = "LONG_VAL"
            }
            else if(value.type =="boolean") {
              value.type = "BOOL_VAL"
            }
            else if(value.type =="string") {
              this.makeToast("danger", "값의 형식 에러", "이제 값의 형식으로 string을 더 이상 사용할 수 없습니다. 형식이 string인 값은 변경해주시기 바랍니다.")
            }
            if(typeof(value.hide) == "undefined") value.hide = false;
            if(typeof(value.hold) == "undefined") value.hold = false;
          })
        }
      }


    }


  },
  updated: function() {
  },

  methods: {

    goSerialWifiConfig: function() {
      this.$router.push({path: "/d/" + this.pageDevice.id + "?mode=serial&action=setWifi"})
    },
    createSensorsJson: function() {
      let sensorsJsonFile = new Blob([JSON.stringify(this.sensorsJsonSource)], {
        type: "text/plain;charset=utf-8"
      });

      if(this.sensorsJsonDownloadURL != null) {
        URL.revokeObjectURL(this.sensorsJsonDownloadURL);
        this.sensorsJsonDownloadURL = null;
      }
      this.sensorsJsonDownloadURL = URL.createObjectURL(sensorsJsonFile);
    },

    toggleSensorCollapsed: function(id) {
      this.$root.$emit("bv::toggle::collapse", "sensorBlock_" + id)
    },

    addNewSensor: function(autoAdd=false) {

      let sensorCount = this.countAttributes(this.pageDevice.sensors)
      if(sensorCount > 7) {
        this.makeToast("danger", "센서 추가 실패", "하나의 기기에는 최대 7개의 센서를 추가할 수 있습니다. 추가된 센서 수:" + sensorCount)
        return;
      }
      if(!autoAdd) {
        if(!window.document.getElementById("newSensorForm").reportValidity()) {
          this.makeToast("danger", "센서 추가 실패", "잘못된 입력 값이 있습니다.");
          return;
        }
      }

      for(let sensor in this.pageDevice.sensors) {
        if(this.newSensor.name == this.pageDevice.sensors[sensor].name) {
          this.makeToast("danger", "센서 추가 실패", "동일한 이름의 센서가 있습니다. 센서의 이름을 변경해주세요.")
          window.document.getElementById("newSensorName").focus()
          return;
        }
      }

      let toAddValues = [];
      let toAddIndexes = {};

      this.newSensor.values.forEach((item,index) => {
        if(typeof(toAddIndexes[item.name]) == "undefined") {
          if(typeof(doNotUse[item.name]) != "undefined" && doNotUse[item.name] == true) {
            this.makeToast("danger", "센서 추가 실패", "값의 이름으로는 " + doNotUse.join(",") + "을 사용할 수 없습니다. 사용할 수 없는 이름:" + item.name);
            return;
          }
          toAddIndexes[item.name] = index;
          let toAddValue = {};
          if(typeof(item.name) != "undefined") toAddValue.name = item.name;
          if(typeof(item.title) != "undefined") toAddValue.title = item.title;
          if(typeof(item.type) != "undefined") toAddValue.type = item.type;
          if(typeof(item.unit) != "undefined" && item.unit != "") toAddValue.unit = item.unit;
          if(typeof(item.max) != "undefined" && item.max != "") toAddValue.max = item.max*1;
          if(typeof(item.min) != "undefined" && item.min != "") toAddValue.min = item.min*1;
          if(typeof(item.diff) != "undefined" && item.diff != "") toAddValue.diff = item.diff*1;
          if(typeof(item.hide) != "undefined") toAddValue.hide = item.hide;
          if(typeof(item.hold) != "undefined") toAddValue.hold = item.hold;
          toAddValues.push(toAddValue);
        }
        else {
          this.makeToast("danger", "센서 추가 실패", "하나의 센서 안에 포함된 데이터는 동일한 이름을 사용할 수 없습니다. 중복된 데이터 이름:" + item.name);
          window.document.getElementById("newSensorValueName" + index).focus();
          return;
        }
      })

      let toAdd = {
        name : this.newSensor.name,
        title: this.newSensor.title,
        type: this.newSensor.type,
        category: this.newSensor.category,
        creation: firebase.firestore.FieldValue.serverTimestamp(),
        lastValuesModified: null,
        values: toAddValues,
        inherit: this.pageDevice.inherit,
        disabled: this.pageDevice.disabled,
        open: this.pageDevice.open,
        frApp: this.pageDevice.frApp,
        frAppCache: this.pageDevice.frAppCache,
        admin: this.pageDevice.admin,
        device: this.pageDevice.id,
        owner: this.pageUser.id,
        lastBook: 0,
        lastIndex: -1,
        lastValues: null,
        bookInfo: {},
      };

      if(this.newSensor.category == "analog" || this.newSensor.category == "digital") {
        Object.assign(toAdd, {
          pin: this.newSensor.pin,
        });
      }
      else if(this.newSensor.category == "i2c") {
        Object.assign(toAdd, {
          address: this.newSensor.address,
        });
      }
      else if(this.newSensor.category == "serial") {
        Object.assign(toAdd, {
          rx: this.newSensor.rx,
          tx: this.newSensor.tx,
        });
      }
      if(typeof(this.pageDevice.oAdmin) != "undefined") {
        toAdd.oAdmin = this.pageDevice.oAdmin;
      }
      if(this.newSensor.read != "") {
        toAdd.read = this.newSensor.read
      }
      if(this.newSensor.update != "") {
        toAdd.update = this.newSensor.update
      }

      let batch = db.batch();
      let newSensor = db.collection("sensors").doc();
      batch.set(newSensor, toAdd);
      batch.update(db.collection("devices").doc(this.pageDevice.id), {
        ["sensors." + this.newSensor.name]: newSensor,
        "lastModified": firebase.firestore.FieldValue.serverTimestamp()
      });
      batch.commit()
      .then(() => {
        this.makeToast("success", "센서 추가 성공", "새로운 센서를 추가했습니다.");
        this.$set(this.sensorsCollapsed, this.newSensor.name, true);
        this.newSensor = { name: "", title: "", values: [] }
        this.predefinedValuesOptionsSelected[newSensor.id] = null
        this.hideModal("addNewSensorFloat");
        this.newlyAddedSensorId = newSensor.id;
      })
      .catch(error => {
        this.makeToast("danger", "센서 추가 실패", "새로운 센서를 추가하는 중에 에러가 발생했습니다. 에러내용:" + error)
      })
    },

    applyPredefinedSensor: function(autoAdd=false) {
      if(this.action != "addSensor") {
        this.newSensor.name = "";
      }
      this.newSensor.title = "CUSTOM 센서";
      this.newSensor.type = "CUSTOM";
      this.newSensor.read = "";
      this.newSensor.update = "";
      this.newSensor.category = "etc";
      this.newSensor.rx = "";
      this.newSensor.tx = "";
      this.newSensor.pin = "";
      this.newSensor.address = "";

      let sensor = this.predefinedSensorsOptionsSelected.newSensor;

      if(typeof(sensor.name) != "undefined") this.newSensor.name = sensor.name;
      if(typeof(sensor.title) != "undefined") this.newSensor.title= sensor.title;
      if(typeof(sensor.type) != "undefined") this.newSensor.type= sensor.type;
      if(typeof(sensor.read) != "undefined") this.newSensor.read= sensor.read;
      if(typeof(sensor.update) != "undefined") this.newSensor.update = sensor.update;
      if(typeof(sensor.category) != "undefined") this.newSensor.category= sensor.category;
      if(typeof(sensor.address) != "undefined") this.newSensor.address= sensor.address;
      if(typeof(sensor.pin) != "undefined") this.newSensor.pin= sensor.pin;
      if(typeof(sensor.rx) != "undefined") this.newSensor.rx= sensor.rx;
      if(typeof(sensor.tx) != "undefined") this.newSensor.tx= sensor.tx;

      let newValues = [];
      sensor.values.forEach(item=> {
        let newValue = {};
        if(typeof(item.value.name) != "undefined") newValue.name = item.value.name;
        if(typeof(item.value.title) != "undefined") newValue.title = item.value.title;
        if(typeof(item.value.type) != "undefined") newValue.type = item.value.type;
        if(typeof(item.value.unit) != "undefined") newValue.unit = item.value.unit;
        if(typeof(item.value.max) != "undefined") newValue.max = item.value.max*1;
        if(typeof(item.value.min) != "undefined") newValue.min = item.value.min*1;
        if(typeof(item.value.diff) != "undefined") newValue.diff = item.value.diff*1;
        if(typeof(item.value.hide) != "undefined") newValue.hide = item.value.hide;
        if(typeof(item.value.hold) != "undefined") newValue.hold = item.value.hold;
        newValues.push(newValue);
      });

      this.newSensor.values = newValues;
      this.predefinedSensorsOptionsSelected.newSensor = null;

      if(autoAdd) {
        this.addNewSensor(true);
      }
    },

    deleteNewSensorValue: function(index) {
      this.newSensor.values.splice(index, 1)
    },
    upNewSensorValue: function(index) {
      let item = this.newSensor.values[index]
      this.newSensor.values.splice(index, 1)
      this.newSensor.values.splice(index-1,0, item)
    },
    downNewSensorValue: function(index) {
      let item = this.newSensor.values[index]
      this.newSensor.values.splice(index, 1)
      this.newSensor.values.splice(index+1,0, item)
    },

    updateSensor: function(sensor, evt) {
      if(typeof(evt) != "undefined") {
        evt.stopPropagation();
      }
      if(!this.pageBinded) {
        this.makeToast("danger", "센서 수정 실패", "실시간이 꺼졌습니다. 센서 수정은 실시간이 켜진 상태에서만 가능합니다.")
        return;
      }

      if(this.pageDevice.sensors[sensor].lastValues != null) {
        let sensorsLength = 0
        this.pageDevice.sensors[sensor].values.forEach(value=>{
          if(!value.hold) sensorsLength++
        })

        if(sensorsLength != this.pageDevice.sensors[sensor].lastValues.v.length) {
          this.makeToast("danger", "센서 수정 실패", "저장된 데이터와 수정된 데이터 형식의 필드 갯수가 다릅니다. 저장된 데이터의 필드: " +
          (this.pageDevice.sensors[sensor].lastValues.v.length-1) +
          "개, 수정된 데이터의 필드: " + sensorsLength +
          "개. 센서의 데이터 필드 수를 변경하는 경우에는 센서에 저장된 데이터를 모두 지워야 합니다.")
          return;
        }
      }

      if(!window.document.getElementById("sensorForm_" + sensor).reportValidity()) {
        this.makeToast("danger", "센서 수정 실패", "잘못된 입력 값이 있습니다.")
        return;
      }

      let toAddValues = []
      let toAddIndexes = {}

      for(let i=0;i<this.pageDevice.sensors[sensor].values.length;i++) {
        if(typeof(toAddIndexes[this.pageDevice.sensors[sensor].values[i].name]) == "undefined") {
          toAddIndexes[this.pageDevice.sensors[sensor].values[i].name] = i;
        }
        else {
          this.makeToast("danger", "센서 수정 실패", "하나의 센서 안에 포함된 데이터는 동일한 이름을 사용할 수 없습니다. 중복된 데이터 이름:" + this.pageDevice.sensors[sensor].values[i].name);
          window.document.getElementById("newSensorValueName_" + sensor + "_" + i).focus();
          return;
        }
        let toAddValue = {
          "name": this.pageDevice.sensors[sensor].values[i].name
        }

        if(typeof(this.pageDevice.sensors[sensor].values[i].title) !="undefined" && this.pageDevice.sensors[sensor].values[i].title != "")
        toAddValue.title = this.pageDevice.sensors[sensor].values[i].title
        if(typeof(this.pageDevice.sensors[sensor].values[i].type) !="undefined")
        toAddValue.type = this.pageDevice.sensors[sensor].values[i].type
        if(typeof(this.pageDevice.sensors[sensor].values[i].unit) !="undefined" && this.pageDevice.sensors[sensor].values[i].unit != "")
        toAddValue.unit = this.pageDevice.sensors[sensor].values[i].unit
        if(typeof(this.pageDevice.sensors[sensor].values[i].max) !="undefined" && this.pageDevice.sensors[sensor].values[i].max != "")
        toAddValue.max = this.pageDevice.sensors[sensor].values[i].max*1
        if(typeof(this.pageDevice.sensors[sensor].values[i].min) !="undefined" && this.pageDevice.sensors[sensor].values[i].min != "")
        toAddValue.min = this.pageDevice.sensors[sensor].values[i].min*1
        if(typeof(this.pageDevice.sensors[sensor].values[i].diff) !="undefined" && this.pageDevice.sensors[sensor].values[i].diff != "")
        toAddValue.diff = this.pageDevice.sensors[sensor].values[i].diff*1
        if(typeof(this.pageDevice.sensors[sensor].values[i].hide) !="undefined")
        toAddValue.hide = this.pageDevice.sensors[sensor].values[i].hide
        if(typeof(this.pageDevice.sensors[sensor].values[i].hold) !="undefined")
        toAddValue.hold = this.pageDevice.sensors[sensor].values[i].hold
        toAddValues.push(toAddValue)
      }

      let toAddSensor = {
        "title": this.pageDevice.sensors[sensor].title,
        "disabled": this.pageDevice.sensors[sensor].disabled,
        "values": toAddValues,
        "type": this.pageDevice.sensors[sensor].type,
        "category": this.pageDevice.sensors[sensor].category
      }

      if(typeof(this.pageDevice.sensors[sensor].read) !="undefined" && this.pageDevice.sensors[sensor].read != "") {
        toAddSensor.read = this.pageDevice.sensors[sensor].read
      }
      else {
        toAddSensor.read = firebase.firestore.FieldValue.delete()
      }

      if(typeof(this.pageDevice.sensors[sensor].update) !="undefined" && this.pageDevice.sensors[sensor].update != "") {
        toAddSensor.update = this.pageDevice.sensors[sensor].update
      }
      else {
        toAddSensor.update = firebase.firestore.FieldValue.delete()
      }

      if(typeof(this.pageDevice.sensors[sensor].type) !="undefined" && this.pageDevice.sensors[sensor].type == "CUSTOM") {
        toAddSensor.category = this.pageDevice.sensors[sensor].category
      }

      if(this.pageDevice.sensors[sensor].category == "analog" || this.pageDevice.sensors[sensor].category == "digital") {
        if(typeof(this.pageDevice.sensors[sensor].pin) !="undefined" && this.pageDevice.sensors[sensor].pin != "") {
          toAddSensor.pin = this.pageDevice.sensors[sensor].pin
        }
        else {
          toAddSensor.pin = firebase.firestore.FieldValue.delete()
        }
      }
      else if(this.pageDevice.sensors[sensor].category == "i2c") {
        if(typeof(this.pageDevice.sensors[sensor].address) !="undefined" && this.pageDevice.sensors[sensor].address != "") {
          toAddSensor.address = this.pageDevice.sensors[sensor].address
        }
        else {
          toAddSensor.address = firebase.firestore.FieldValue.delete()
        }
      }
      else if(this.pageDevice.sensors[sensor].type == "serial") {
        if(typeof(this.pageDevice.sensors[sensor].rx) !="undefined" && this.pageDevice.sensors[sensor].rx != "") {
          toAddSensor.rx = this.pageDevice.sensors[sensor].rx
        }
        else {
          toAddSensor.rx = firebase.firestore.FieldValue.delete()
        }
        if(typeof(this.pageDevice.sensors[sensor].tx) !="undefined" && this.pageDevice.sensors[sensor].tx != "") {
          toAddSensor.tx = this.pageDevice.sensors[sensor].tx
        }
        else {
          toAddSensor.tx = firebase.firestore.FieldValue.delete()
        }
      }

      db.collection("sensors").doc(this.pageDevice.sensors[sensor].id).update(toAddSensor)
      .then(() => {
        this.makeToast("success", "센서 수정 성공", "수정된 센서 정보를 서버에 저장했습니다.")
      })
      .catch(error => {
        this.makeToast("danger", "센서 수정 실패", "수정된 센서 정보를 서버에 저장하다가 에러가 발생했습니다. 에러 내용:" + error)
      })
    },

    deleteSensorData: function(sensor, evt) {
      if(typeof(evt) != "undefined") {
        evt.stopPropagation();
      }

      this.$bvModal.msgBoxConfirm("센서의 데이터를 삭제한 후에 취소할 수 없습니다. " + sensor + " 센서의 데이터를 삭제하시겠습니까?", {
        size: "sm",
        buttonSize: "sm",
        okVariant: "secondary",
        okTitle: sensor + " 센서 데이터 삭제",
        cancelTitle: "취소",
        cancelVariant: "danger",
        bodyClass: "gothic",
        footerClass: "p-1 pr-3",
        hideHeaderClose: true,
      })
      .then(confirmed => {
        if(confirmed) {
          let oldActive = this.pageDevice.active;
          let sensorId = this.pageDevice.sensors[sensor].id
          if(oldActive) {
            db.collection("devices").doc(this.pageDevice.id).update({
              active: false
            })
          }

          db.collection("sensors").doc(sensorId).collection("history")
          .get()
          .then(result => {

            let deleted = 0;
            result.docs.forEach(doc => {
                db.collection("sensors").doc(sensorId).collection("history").doc(doc.id).delete()
                .then(() => {
                  deleted++;
                  if(deleted == result.docs.length) {
                    db.collection("sensors").doc(sensorId)
                    .set({
                      bookInfo: {},
                      lastValues: null,
                      lastValuesModified: null,
                      lastBook: 0,
                      lastIndex: -1,
                    },{ merge: true })
                    .then(() => {
                      this.makeToast("info", "데이터 삭제 완료", "센서를 초기화 했습니다.", {
                        "autoHideDelay": 3000
                      });

                      this.removeBackupUri(sensor);

                      this.$set(this.showDeleteButton, sensor, false);

                      if(oldActive) {
                        db.collection("devices").doc(this.pageDevice.id).update({
                          active: oldActive
                        })
                      }
                    });
                  }
                });
            });
          });
        }
      });
    },

    removeBackupUri: function(sensor, evt) {
      if(typeof(evt) != "undefined") {
        evt.stopPropagation();
      }
      if(typeof(this.backupUri[sensor]) != "undefined" && this.backupUri[sensor] != null) {
        URL.revokeObjectURL(this.backupUri[sensor]);
        this.$set(this.backupUri, sensor, null);
      }
    },



    backupSensorData: function(sensor, evt) {
      if(typeof(evt) != "undefined") {
        evt.stopPropagation();
      }

      let items = [];
      let successCount = 0;
      let bookList = {};
      let totalRow = (this.pageDevice.sensors[sensor].lastBook*1000) + this.pageDevice.sensors[sensor].lastIndex + 1;

      this.$bvToast.show("backupSensorDataToast");
      this.doingBackup = true;
      this.backupSensorDataMessage = (totalRow>10000)?"서버에서 데이터를 가져오는 중입니다. 데이터가 많아 시간이 오래 걸립니다.":"서버에서 데이터를 가져오는 중입니다.";

      for(let bookIndex in this.pageDevice.sensors[sensor].bookInfo) {
        db.collection("sensors").doc(this.pageDevice.sensors[sensor].id).collection("history").doc(bookIndex+ "")
        .get()
        .then(book => {
          if(book.exists) {

            bookList[book.id] = book.data();

            if(successCount++ == this.pageDevice.sensors[sensor].lastBook) {

              this.backupSensorDataMessage = (totalRow>10000)?"데이터를 모두 가져왔습니다. 파일을 만듭니다. 데이터가 많아 시간이 오래 걸립니다.":"데이터를 모두 가져왔습니다. 파일을 만듭니다.";

              for(let i=0;i<=this.pageDevice.sensors[sensor].lastBook;i++) {
                let endId = (i == this.pageDevice.sensors[sensor].lastBook)? this.pageDevice.sensors[sensor].lastIndex: 999;
                for(let j=0;j<=endId;j++) {
                  items.push([bookList[i + ""][j+""].t.seconds, ...bookList[i + ""][j+""  ].v].join(","));
                }
              }

              let blob = new Blob([items.join("\n")], {
                type: "text/plain;charset=utf-8"
              });

              if(typeof(this.backupUri[sensor]) != "undefined" && this.backupUri[sensor] != null) {
                URL.revokeObjectURL(this.backupUri[sensor]);
                this.$set(this.backupUri, sensor, null);
              }
              this.$set(this.backupUri, sensor, URL.createObjectURL(blob));

              this.doingBackup = false;
              this.backupSensorDataMessage = "다운로드할 준비가 끝났습니다. 백업파일을 다운로드 하세요.";

              window.setTimeout(()=> {
                this.$bvToast.hide("backupSensorDataToast");
              }, 5000);

            }
          }
          else {
            if(bookIndex == 0) {
              this.makeToast("danger", "백업 실패", "데이터가 없습니다.");
            }
            else {
              this.makeToast("danger", "백업 실패", bookIndex + "번 묶음 데이터가 없습니다.");
            }
          }
        })
        .catch(error => {
          this.makeToast("danger", "백업실패", "데이터 조회 중 에러가 발생했습니다. 에러 내용: " + error);
        })
      }
    },

    deleteSensor: function(sensor, evt) {

      if(typeof(evt) != "undefined") {
        evt.stopPropagation();
      }

      if(!this.pageBinded) {
        this.makeToast("danger", "센서 삭제 실패", "실시간이 꺼졌습니다. 센서 삭제는 실시간이 켜진 상태에서만 가능합니다.")
        return;
      }

      if(this.pageDevice.sensors[sensor].lastBook != 0 || this.pageDevice.sensors[sensor].lastIndex != -1) {

        this.$set(this.showDeleteButton, sensor, true);
        this.makeToast("danger", "센서 삭제 실패", "데이터가 저장된 센서는 삭제할 수 없습니다. 먼저 센서의 데이터를 모두 삭제해주세요.", 3000)
        return;
      }

      if(this.action == "addSensor") {
        let sensorId = this.pageDevice.sensors[sensor].id;
        let batch = db.batch();
        batch.update(db.collection('devices').doc(this.pageDevice.id), {
          ["sensors." + sensor]: firebase.firestore.FieldValue.delete()
        });
        batch.delete(db.collection("sensors").doc(sensorId));
        batch.commit()
        .then(() => {
          this.makeToast("success", "센서 삭제 성공", "센서를 삭제했습니다.")
        })
        .catch(error => {
          this.makeToast("danger", "센서 삭제 실패", "센서를 삭제하다가 에러가 났습니다. 에러내용:" + error)
        })
      }
      else {
        this.$bvModal.msgBoxConfirm("센서를 삭제한 후에 취소할 수 없습니다. " + sensor + " 센서를 삭제하시겠습니까?", {
          size: "sm",
          buttonSize: "md",
          okVariant: "secondary",
          okTitle: sensor + " 센서 삭제",
          cancelTitle: "취소",
          cancelVariant: "danger",
          bodyClass: "gothic",
          footerClass: "p-1 pr-3",
          hideHeaderClose: true,
        })
        .then(confirmed => {
          if(confirmed) {
            let sensorId = this.pageDevice.sensors[sensor].id;
            let batch = db.batch();
            batch.update(db.collection('devices').doc(this.pageDevice.id), {
              ["sensors." + sensor]: firebase.firestore.FieldValue.delete()
            });
            batch.delete(db.collection("sensors").doc(sensorId));
            batch.commit()
            .then(() => {
              this.makeToast("success", "센서 삭제 성공", "센서를 삭제했습니다.")
            })
            .catch(error => {
              this.makeToast("danger", "센서 삭제 실패", "센서를 삭제하다가 에러가 났습니다. 에러내용:" + error)
            })
          }
        });
      }


    },
    addNewValue: function() {
      if(this.predefinedValuesOptionsSelected.newSensor == null) {
        return
      }
      else if(this.newSensor.values.length >= 16) {
        this.makeToast("danger", "데이터 추가 실패", "하나의 센서에는 최대 16개의 칼럼을 지정할 수 있습니다.")
        return
      }
      else {
        this.newSensor.values.push({
          name: "",
          title: "",
          unit: "",
          type: this.predefinedValuesOptionsSelected.newSensor.type,
          // max: this.predefinedValuesOptionsSelected.newSensor.max,
          // min: this.predefinedValuesOptionsSelected.newSensor.min,
          // diff: this.predefinedValuesOptionsSelected.newSensor.diff,
          hide: false,
          hold: false
        })
        this.predefinedValuesOptionsSelected.newSensor = null
      }
    },

    addValue: function(sensor) {
      if(this.predefinedValuesOptionsSelected[sensor] == null) {
        return;
      }
      else if(this.pageDevice.sensors[sensor].values.length >= 16) {
        this.makeToast("danger", "데이터 추가 실패", "하나의 센서에는 최대 16개까지 칼럼을 추가할 수 있습니다.")
        return;
      }
      this.pageDevice.sensors[sensor].values.push({
        name: "",
        title: "",
        unit: "",
        type: this.predefinedValuesOptionsSelected[sensor].type,
        hide: false,
        hold: false
      })
      this.predefinedValuesOptionsSelected[sensor] = null
      window.document.getElementById('addValueSelect_' + sensor).selectedIndex = -1
    },

    deleteValue: function(sensor, index) {
      this.pageDevice.sensors[sensor].values.splice(index, 1)
    },
    upValue: function(sensor, index) {
      let item = this.pageDevice.sensors[sensor].values[index]
      this.pageDevice.sensors[sensor].values.splice(index, 1)
      this.pageDevice.sensors[sensor].values.splice(index-1,0, item)
    },

    downValue: function(sensor, index) {
      let item = this.pageDevice.sensors[sensor].values[index]
      this.pageDevice.sensors[sensor].values.splice(index, 1)
      this.pageDevice.sensors[sensor].values.splice(index+1,0, item)
    },
  },
  computed: {

    sensorsJsonSourceText: function() {
      return JSON.stringify(this.sensorsJsonSource, null, '\t');
    },

    sensorsJsonSource: function() {
      let result = [];
      for(let sensorName in this.pageDevice.sensors) {
        let sensor = this.pageDevice.sensors[sensorName];
        if(typeof(sensor.disabled) == "undefined" || sensor.disabled == false) {
          let sensorObj = {
            "na": sensor.name,
            "va": []
          }
          if(typeof(sensor.type) == "undefined") {
            sensorObj.ty = this.sensorType["CUSTOM"];
          }
          else {
            sensorObj.ty = this.sensorType[sensor.type];
          }

          if(typeof(sensor.read) != "undefined" && sensor.read >= 0 && sensor.read != "") {
            sensorObj.re = sensor.read*1
          }
          if(typeof(sensor.update) != "undefined" && sensor.update >= 0 && sensor.update != "") {
            sensorObj.up = sensor.update*1
          }

          if(typeof(sensor.address) != "undefined" && sensor.address != "") {
            sensorObj.ad = sensor.address
          }
          else if(typeof(sensor.pin) != "undefined" && sensor.pin != "") {
            sensorObj.pi = sensor.pin
          }
          else {
            if(typeof(sensor.rx) != "undefined" && sensor.rx != "") {
              sensorObj.rx = sensor.rx
            }
            if(typeof(sensor.tx) != "undefined" && sensor.tx != "") {
              sensorObj.tx = sensor.tx
            }
          }

          if(sensor.values) {
            sensor.values.forEach(value=>{
              let valueObj = {
                "na": value.name,
              }
              if(typeof(value.unit) != "undefined" && value.unit != "") {
                valueObj.un = value.unit;
              }
              if(typeof(value.hide) != "undefined" && value.hide != false) {
                valueObj.hi = 1;
              }
              if(typeof(value.hold) != "undefined" && value.hold != false) {
                valueObj.ho = 1;
              }
              switch(value.type) {
                case "number": valueObj.ty = this.valueType["FLOAT_VAL"]
                break;
                case "int": valueObj.ty = this.valueType["INT_VAL"]
                break;
                case "boolean": valueObj.ty = this.valueType["BOOL_VAL"]
                break;
                case "string": valueObj.ty = this.valueType["INT_VAL"]
                break;
                default: valueObj.ty = this.valueType[value.type]
              }

              if(typeof(value.max) == "number" && !isNaN(value.max*1)) {
                valueObj.ma = value.max*1;
              }
              if(typeof(value.min) == "number" && !isNaN(value.min*1)) {
                valueObj.mi = value.min*1
              }
              if(typeof(value.diff) == "number" && !isNaN(value.diff*1)) {
                valueObj.di = value.diff;
              }
              sensorObj.va.push(valueObj)
            })
          }
          result.push(sensorObj)
        }
      }
      return result;
    },

    pageDeviceSensorsLength: function() {
      return this.countAttributes(this.pageDevice.sensors);
    },
    
    sortedSensors: function() {
      let list = []
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.pageDevice.sensors)) {
        if(typeof(value) != "string") {
          list.push(value)
        }
      }

      list.sort(function(a,b) {
        if(b.creation == null) return 1;
        else if(a.creation == null) return -1;
        else if(typeof(a.creation) != "undefined" && typeof(b.creation) != "undefined") {
          if(a.creation.seconds == b.creation.seconds) {
            return ('' + b.name).localeCompare(a.name);
          }
          else {
            return b.creation.seconds - a.creation.seconds;
          }
        }
        else {
          return 0;
        }
      })
      return list
    },
  }
}
</script>
<style>
  .notOwner input { background-color : white !important; }
  .notOwner select { background-color : white !important; }
  .notOwner textarea { background-color : white !important; }
  #predefinedSensorsSelect option {
    min-height: 1.5em !important;
    padding-top: 0.3rem !important;
    padding-bottom: 0.3rem !important;
  }
</style>
